import "./styles.css";
export const DashLayoutListCourse = (props) => {
  return (
    <div class="container-dash-list" style={{ display: "table-cell"}}>
      <div className="container-login-dash-list">
        <div className="wrap-login-dash-list">{props.children}</div>
      </div>
    </div>
  );
};
